<div class="callback-header" *ngIf="!fullscreen">
  <div class="menu-hover">
    <div></div>
  </div>
  <div class="search-container">
    <app-textbox class="filter-box" [model]="filterString" (modelChange)="filterRecords($event)"
      placeholder="{{ 'Search' | i18next }}" textboxWidth="300px"></app-textbox>
    <i class="fal fa-search"></i>
  </div>
  <div class="buttons-container">
    <button (click)="addNew()" [matTooltip]="'callbackDisplay:Add Configuration' | i18next "
      matTooltipClass="tooltip-font-14"> <i class="far fa-plus"></i></button>
  </div>
</div>
<div class="callback-container">
  <div class="callback-list" [class.edit-mode]="selectedConfigId||addNewConfig" *ngIf="!fullscreen">
    <div class="callback-list-title">
      <span>{{ 'callbackDisplay:Callback Display page parameters list' | i18next }}</span>
    </div>
    <div class="callback-list-items thin-scroll" [class.empty-callback-list]="configurations.length==0">
      <div class="callback-list-row" *ngFor="let item of configurations| filter : 'name' : filterString " [class.selected]="item.id==selectedConfigId">
        <div class="name" (click)="edit(item.id)"> {{item.name}}</div>
        <div class="main-text" *ngIf="!(selectedConfigId||addNewConfig)"> {{item.mainText}}</div>
        <div class="buttons">
          <button (click)="edit(item.id)" [matTooltip]="'Edit' | i18next " matTooltipClass="tooltip-font-14"><i
              [ngClass]="['fal fa-edit', 'edit-icon']"></i></button>
          <button (click)="delete(item.id)" [matTooltip]="'Delete' | i18next" matTooltipClass="tooltip-font-14"><i
              [ngClass]="['fal fa-trash-alt', 'delete-icon']"></i></button>
        </div>
      </div>
      <div *ngIf="configurations.length==0" class="no-records">
        <div>{{ 'callbackDisplay:Add Configuration' | i18next }}</div>
        <button (click)="addNew()" [matTooltip]="'callbackDisplay:Add Configuration' | i18next "
          matTooltipClass="tooltip-font-14"><i class="far fa-plus"></i></button>
      </div>
    </div>
  </div>
    <div class="callback-details">
      <app-callback-display-config *ngIf="selectedConfigId||addNewConfig" [configId]="selectedConfigId" (closeEvent)="hideDetails()"
       (refreshEvent)="getConfigs()" [id]="selectedConfigId" [isNew]="addNewConfig" (fullscreenEvent)="onFullscreen($event)"></app-callback-display-config>
    </div>
